import { render, staticRenderFns } from "./send-contact-dialog.vue?vue&type=template&id=86531ce8&scoped=true&"
import script from "./send-contact-dialog.vue?vue&type=script&lang=js&"
export * from "./send-contact-dialog.vue?vue&type=script&lang=js&"
import style0 from "./send-contact-dialog.vue?vue&type=style&index=0&id=86531ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86531ce8",
  null
  
)

export default component.exports